import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';
import styled from '@emotion/styled';
import vars from '@variables';

export const FlipcardContainer = styled.div<{ isFlippable: boolean }>`
  width: 100%;
  aspect-ratio: 1 / 1;
  perspective: 1000px;
  cursor: ${({ isFlippable }) => (isFlippable ? 'pointer' : 'auto')};

  * {
    color: white;
  }
`;

export const FlipcardInner = styled.div<{ isFlipped: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  transform: ${props => (props.isFlipped ? 'rotateY(180deg)' : 'rotateY(0)')};
`;

export const FlipcardSide = styled.div<{
  backgroundColor?: string;
  isBack: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 8px;
  overflow: hidden;
  transform: ${props => (props.isBack ? 'rotateY(180deg)' : 'rotateY(0)')};
  background-color: ${props => props.backgroundColor};
  color: white;
`;

export const FlipcardBackground = styled.div<{
  backgroundImage?: string;
  darkOverlay?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${props =>
    props.backgroundImage ? `url(${props.backgroundImage})` : 'none'};
  background-size: cover;
  background-position: center;
  ${props =>
    props.darkOverlay &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }
  `}
`;

export const FlipcardContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 24px;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: ${vars.fontSize2};

  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

  ${PAtom} {
    font-size: ${vars.fontSize2};
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: ${vars.fontSize2};
`;

export const FlipcardBadge = styled.div<{
  backgroundColor?: string;
}>`
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: bold;
  text-transform: uppercase;
  align-self: flex-start;
  
  font-size: ${vars.fontSize1}
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  text-shadow: none;
`;

export const FlipcardTitle = styled(H2Atom)`
  font-size: ${vars.fontSize7};
  text-align: left;
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  -webkit-line-clamp: 6;

  @media (min-width: 768px) and (max-width: 1023px) {
    -webkit-line-clamp: 4;
  }

  @media (min-width: 1024px) {
    -webkit-line-clamp: 6;
  }
`;

export const FlipIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const BackText = styled.p`
  line-height: 1.5;
`;
